<template>
    <ModalLayout :title="title" @close="cancel">
        <div class="space-y-5">
            <p class="text-sm leading-6 text-gray-600 dark:text-txt-body">
                {{ description }}
            </p>

            <CFormGroup :label="messageLabel">
                <CFormTextarea
                    v-model="message"
                    class="min-h-28"
                    :placeholder="messagePlaceholder"
                />
            </CFormGroup>
        </div>

        <template #footer>
            <div class="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
                <CButton variant="outline" @click="cancel">
                    Zrušiť
                </CButton>
                <CButton variant="decline" @click="submit">
                    {{ submitLabel }}
                </CButton>
            </div>
        </template>
    </ModalLayout>
</template>

<script setup lang="ts">
import ModalLayout from '@/components/ui/layouts/ModalLayout.vue'

interface RejectPreStartMentoringModalResult {
    messageForMentee?: string
}

const props = withDefaults(
    defineProps<{
        isMentor?: boolean
        partnerName?: string
    }>(),
    {
        isMentor: false,
        partnerName: 'druhej strane'
    }
)

const emit = defineEmits<{
    (e: 'close', data: RejectPreStartMentoringModalResult | null): void
}>()

const message = ref('')

const title = computed(() => (props.isMentor ? 'Odmietnuť žiadosť' : 'Odmietnuť ponuku'))
const submitLabel = computed(() => (props.isMentor ? 'Odmietnuť žiadosť' : 'Odmietnuť ponuku'))
const description = computed(() => {
    return props.isMentor
        ? `Mentoring s ${props.partnerName} označíme ako odmietnutý. Ak doplníš správu, odošleme ju aj do chatu.`
        : `Ponuku mentoringu od ${props.partnerName} označíme ako odmietnutú. Ak doplníš správu, odošleme ju aj do chatu.`
})
const messageLabel = computed(() => {
    return props.isMentor ? 'Správa pre menteeho (voliteľné)' : 'Správa pre mentora (voliteľné)'
})
const messagePlaceholder = computed(() => {
    return props.isMentor
        ? 'Napríklad: Ďakujem za záujem, ale momentálne ťa nemôžem mentorovať.'
        : 'Napríklad: Ďakujem za ponuku, ale momentálne nechcem v mentoringu pokračovať.'
})

function cancel() {
    emit('close', null)
}

function submit() {
    const trimmedMessage = message.value.trim()
    emit('close', trimmedMessage ? { messageForMentee: trimmedMessage } : {})
}
</script>
